import { render, staticRenderFns } from "./MasterClassesPromoBanner.vue?vue&type=template&id=c4f79fe0&scoped=true"
import script from "./MasterClassesPromoBanner.vue?vue&type=script&lang=js"
export * from "./MasterClassesPromoBanner.vue?vue&type=script&lang=js"
import style0 from "./MasterClassesPromoBanner.vue?vue&type=style&index=0&id=c4f79fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f79fe0",
  null
  
)

export default component.exports